














import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from 'vue-typedi';
import {Customer} from '@/model/Customer';
import {CustomerService} from '@/services/CustomerService';
import CustomerDialog from '@/components/dialog-box/CustomerDialog.vue';

@Component({
  components: { CustomerDialog }
})
export default class CustomerData extends Vue {
    @Prop({default: null}) orderNumber: string;

    @Inject()
    customerService!: CustomerService;

    customer: Customer = null;
    isDialogOpen: boolean = false;

    public displayCustomerData() {
        this.customerService.getCustomerData(this.orderNumber)
            .then((customer: Customer) => {
                this.customer = customer;
                this.isDialogOpen = true;
            });
    }
}
